import { Grid, Segment, Container } from 'semantic-ui-react';
import { isEmpty, map } from '../../utils/lodash';
import { EmptyContainer } from '../../components';
import { useTranslation } from 'react-i18next';

const ACTIVITIES = (t) => [
  {
    titleKey: t('activity_status.in_development'),
    key: 'in-development',
    color: '#FF781D',
  },
  {
    titleKey: t('activity_status.active'),
    key: 'active',
    color: '#339933',
  },
  {
    titleKey: t('activity_status.completed'),
    key: 'completed',
    color: '#003398',
  },
];

const INVITED_ACTIVITIES = (t) => [
  {
    titleKey: t('activity_status.active'),
    key: 'active',
    color: '#339933',
  },
];

export const ActivityStateSegment = ({ statUser = {}, loading, user = {} }) => {
  const { t } = useTranslation();

  return (
    <Segment className="content-segment-dashboard" loading={loading}>
      {isEmpty(statUser) ? (
        <EmptyContainer />
      ) : (
        <Grid>
          <Grid.Row>
            <div className="dashboard-act-container">
              <label className="dashboard-act-heading">
                {t('common.managed_activities')}
              </label>
              {map(ACTIVITIES(t), (item, i) => (
                <Grid.Row key={i} className="no-padding">
                  <Container className="no-padding">
                    <div className="activity-cont">
                      <label
                        className="activity-count-owned"
                        style={{
                          color: item.color,
                        }}
                      >
                        {statUser.owned[item.key]
                          ? String(statUser.owned[item.key]).padStart(2, '0')
                          : 0}
                      </label>
                      <label className="activity-title">
                        {t(item.titleKey)}
                      </label>
                    </div>
                  </Container>
                </Grid.Row>
              ))}
            </div>
          </Grid.Row>
          <Grid.Row>
            <div className="dashboard-act-container-invited">
              <label className="dashboard-act-heading">
                {t('common.invited_activities')}
              </label>
              {map(INVITED_ACTIVITIES(t), (item, i) => (
                <Grid.Row key={i} className="no-padding">
                  <Container className="no-padding">
                    <div className="activity-cont">
                      <label
                        className="activity-count-invited"
                        style={{
                          color: item.color,
                        }}
                      >
                        {statUser.invited[item.key]
                          ? String(statUser.invited[item.key]).padStart(2, '0')
                          : 0}
                      </label>
                      <label className="activity-title">
                        {t(item.titleKey)}
                      </label>
                    </div>
                  </Container>
                </Grid.Row>
              ))}
              <label className="dashboard-act-info">
                {t('dashboard.invited_only_in_progress')}
              </label>
            </div>
          </Grid.Row>
        </Grid>
      )}
    </Segment>
  );
};

export default ActivityStateSegment;
